export const IMG = {
  heroClinic: "https://images.unsplash.com/photo-1541752857837-f8a0154fd092",
  heroPortraitAlt: "https://images.unsplash.com/photo-1746410848313-2b3e7c180977",
  examRoom: "https://images.pexels.com/photos/7789602/pexels-photo-7789602.jpeg",
  waiting: "https://images.pexels.com/photos/8459996/pexels-photo-8459996.jpeg",
  empathy: "https://customer-assets-39nsmqrw.emergentagent.net/job_restorative-care-ca/artifacts/z69920nc_IMG_9480.webp",
  skinBack: "https://images.unsplash.com/photo-1541752857837-f8a0154fd092",
  skinMacro: "https://images.unsplash.com/photo-1710580889701-9fa8f2cd5927",
  cream: "https://images.unsplash.com/photo-1585945037805-5fd82c2e60b1",
  portrait: "https://images.pexels.com/photos/6076115/pexels-photo-6076115.jpeg",
  clinicWarm: "https://images.unsplash.com/photo-1762625570087-6d98fca29531",
};
